<template>
  <Languagecode />
</template>

<script>
import Vue from 'vue';

import Languagecode from '@/components/Languagecode.vue';

export default Vue.extend({
  
  components: {
    Languagecode,
  },
   
});
</script>
